import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import AntRow from "antd/es/grid/row";
import classnames from "../../utils/classnames.js";
import './Grid.css';/* empty css          */
const Row = ({ className, children, gutter, background = "default", ...props }) => {
  const resolvedGutter = useMemo(() => {
    if (Array.isArray(gutter) && typeof gutter[1] === "string") {
      return [gutter[0], `var(--perxis-auto-gap-${gutter[1]}-inner)`];
    }
    return gutter;
  }, [gutter]);
  return /* @__PURE__ */ jsx(
    AntRow,
    {
      gutter: resolvedGutter,
      className: classnames(
        [
          "perxis-auto-row",
          {
            [`perxis-auto-row-background-${background}`]: background !== "default"
          }
        ],
        className
      ),
      ...props,
      children
    }
  );
};
export {
  Row as default
};
//# sourceMappingURL=Row.js.map
